import { render, staticRenderFns } from "./TabUpDejun.vue?vue&type=template&id=556c2926"
import script from "./TabUpDejun.vue?vue&type=script&lang=js"
export * from "./TabUpDejun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports